import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  // constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    // Response
    return next.handle(newReq).pipe(
      //success response
      tap((response: any) => {
        if (
          req.method === 'POST' &&
          response instanceof HttpResponse &&
          response.status >= 200 &&
          response.status < 400
        ) {
          // this.dialog.closeAll();
        }
      }),
      // error response
      catchError((error) => {
        // show api error notifications
        // this.snackBar.open(error.error.message, '', {
        //   panelClass: ['bg-error', 'text-white'],
        // });

        return throwError(error);
      }),
    );
  }
}
